import React from 'react';
import UserName from '../../../../../elements/UserName';
import styles from './MessageBubble.module.scss';

function MessageBubble(props) {
    const { className = '', icon, name, children } = props;

    return (
        <div className={[className, styles.MessageBubble].join(' ')}>
            <div className={styles.icon}>{icon}</div>

            <div className={styles.name}>
                {name}
            </div>
            <div className={styles.content}>{children}</div>
        </div>
    );
}

export default MessageBubble;
